// extracted by mini-css-extract-plugin
export default {"container":"Placeholder_container__cytcQ","buttons":"Placeholder_buttons__U88du","heading":"Placeholder_heading__SIikN"};